import { KngFooterState } from './definitions/footer.interface';

export class KngFooterFactory 
{
	public static buildState(): KngFooterState 
	{
		return {
			ribbonImage: '',
			altText: '',
			cssClass: '',
			footercontent: {
				css: {
					ecomm: ''
				},
				script: {},
				unifiedFooter: ''
			}
		};
	}
}
